import { render, staticRenderFns } from "./merchantDetail.vue?vue&type=template&id=55002aef&scoped=true"
import script from "./merchantDetail.vue?vue&type=script&lang=js"
export * from "./merchantDetail.vue?vue&type=script&lang=js"
import style1 from "./merchantDetail.vue?vue&type=style&index=1&id=55002aef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55002aef",
  null
  
)

export default component.exports